module.exports = __webpack_public_path__ + "static/media/katomaran.00b9490b.svg";